import React from 'react';
import ListView from './ListView';
export default function CreditPools(){
  return <ListView icon="creditPools" title="Credit Pools" subtitle="Per-workspace, per-billing-period credit balance and consumption." path="/credit-pools" columns={["id","workspace_id","period_start","period_end","included_credits","consumed_credits","overage_credits"]} mapRow={r=>r} />;
}
